/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
export const getSitecoreConfig = (env: Record<string, string>) => ({
	sitecoreApiKey: env.SITECORE_API_KEY || "{CAEFB73F-9CBD-4AA9-8A1B-2EEF29F62AD8}",
	sitecoreApiHost: env.SITECORE_API_HOST || "",
	jssAppName: env.JSS_APP_NAME || "aramco-jss",
	defaultLanguage: env.DEFAULT_LANGUAGE || "en",
	sitecoreSiteName: "aramcocom",
	connected: false,
});

export type SitecoreConfig = ReturnType<typeof getSitecoreConfig>;
